import { render, staticRenderFns } from "./NewHelpDetail.vue?vue&type=template&id=7c578003&"
import script from "./NewHelpDetail.vue?vue&type=script&lang=js&"
export * from "./NewHelpDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports